import React from "react";

const context = {
    keyword: ""
};

const HighlightContext = React.createContext(context); //passing initial value

export default HighlightContext;
